module.exports = __webpack_public_path__ + "img/banner.a435d518.png";